import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const postChassisData = async ({ data }) => {
  try {
    const response = await safetyDefaultAPI.post('chassis', data);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default postChassisData;
